import CustomElement from '~utilities/custom-element';

class Menu extends CustomElement {
	constructor() {
		super();
	}


	callback() {
		super.callback();
		const ctaButton = document.getElementsByClassName(['cta--button-menu'])[0];
		const navItems = document.getElementsByClassName(['nav__items'])[0];
		const f = document.getElementsByClassName(['fa-bars'])[0];
		const showMore = document.getElementsByClassName(['c-showmore'])[0];

		let isExpanded;

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				const d = navItems.style.display;
				navItems.style.display = d === 'block' ? 'none' : 'block'
				ctaButton.classList.toggle('close')
				f.classList.toggle('fa-close')
				f.classList.toggle('fa-bars')
				showMore.classList.toggle('hidden')
				
				isExpanded = ctaButton.getAttribute('aria-expanded') == "false"
				ctaButton.setAttribute("aria-expanded", isExpanded)
				
				console.log(isExpanded)
				var codes = [
					...document.querySelectorAll('a'),
					...document.querySelectorAll('button')
				];
				
				for (var i = 0, len = codes.length; i < len; i++) {
					codes[i].setAttribute('tabindex', isExpanded ? '-1' : '0');
				}
				
				
				if (isExpanded) {
					var enableMenuItems = [
						...document.querySelectorAll('.nav__bar-link.root'),
						...document.querySelectorAll('.cta--button.cta--button-contrast'),
						...document.querySelectorAll('.cta--button.cta--button-menu.close')
					];
				
					for (var i = 0, len = enableMenuItems.length; i < len; i++) {
						console.log(enableMenuItems[i])
						enableMenuItems[i].setAttribute('tabindex', '0');
					}
				}
				
				
				document.getElementsByClassName('nav__bar-link')[0].focus()
			}
		});


		ctaButton.addEventListener("click", () => {
			const d = navItems.style.display;
			navItems.style.display = d === 'block' ? 'none' : 'block'
			ctaButton.classList.toggle('close')
			f.classList.toggle('fa-close')
			f.classList.toggle('fa-bars')
			showMore.classList.toggle('hidden')

			isExpanded = ctaButton.getAttribute('aria-expanded') == "false"
			ctaButton.setAttribute("aria-expanded", isExpanded)

			console.log(isExpanded)
			var codes = [
				...document.querySelectorAll('a'),
				...document.querySelectorAll('button')
			];

			for (var i = 0, len = codes.length; i < len; i++) {
				codes[i].setAttribute('tabindex', isExpanded ? '-1' : '0');
			}


			if (isExpanded) {
				var enableMenuItems = [
					...document.querySelectorAll('.nav__bar-link.root'),
					...document.querySelectorAll('.cta--button.cta--button-contrast'),
					...document.querySelectorAll('.cta--button.cta--button-menu.close')
				];

				for (var i = 0, len = enableMenuItems.length; i < len; i++) {
					console.log(enableMenuItems[i])
					enableMenuItems[i].setAttribute('tabindex', '0');
				}
			}


			document.getElementsByClassName('nav__bar-link')[0].focus()

		})

	}

}

export default Menu;
